import React from 'react';

const Button = (props) => {
  const cstyle = props.style + ' flex justify-center items-center cursor-pointer select-none';
  if(props.link){
    return (
      <a href={props.link ? props.link : "#"} className={cstyle}><p>{props.name}<br/>{props.name2}</p></a>
    );
  }else{
    return (
      <div className={cstyle} onClick={props.onclick}><p>{props.name}</p></div>
    );
  }

}

export default Button;